<template>
  <div v-if="terminart" class="pane white-pane initial-height text-dark p-0">
    <div
      v-if="proposal"
      class="font-weight-bold text-blue fs-18 pl-4 pt-4 pr-4 text-primary"
    >
      <template v-if="time">
        {{ time | dateLong }} &bull; {{ time | clock }}
        {{ $t("uhr") }}
      </template>
      <template v-else>
        {{ $t("kein_datum") }}
      </template>
    </div>
    <div class="pl-4 mt-2" :class="{ 'pt-4': !proposal }">
      {{ terminart.bezeichnung[$i18n.locale] || option.titel }}
    </div>
    <br />
    <div class="row no-gutters">
      <div class="col-auto pl-4 pr-2">
        <font-awesome-icon icon="clock" />
      </div>
      <div class="col">
        <div>{{ $t("circa") }} {{ terminart.dauer || proposal.duration }} min</div>
        <div v-if="minDate">{{ $t("ab") }} {{ minDate | dateVeryShort }}</div>
        <div v-if="maxDate">{{ $t("bis") }} {{ maxDate | dateVeryShort }}</div>
      </div>
    </div>
    <br />
    <div class="row no-gutters">
      <div class="col-12 px-4 line-breaks">{{ terminart.beschreibung[$i18n.locale] }}</div>
    </div>
    <br />
    <div class="pl-4 pb-4" style="white-space: pre-line" v-if="praxis">
      {{ praxis.address }}
    </div>
    <!--<hr v-if="proposal && mitarbeiter && mitarbeiter.name" />
    <div v-if="proposal && mitarbeiter && mitarbeiter.name" class="row p-4">
      <div class="col-4">
        <img
          v-if="mitarbeiter && mitarbeiter.bild_kopf"
          class="avatar_big"
          :src="getBild(mitarbeiter.bild_kopf)"
        />
        <avatar-dummy v-else />
      </div>
      <div class="col-8">
        <div class="mb-2">{{ $t("ihr_behandler") }}</div>
        <div
          v-if="mitarbeiter"
          class="font-weight-bold text-blue text-primary"
        >
          {{ mitarbeiter.vorname }} {{ mitarbeiter.name }}
        </div>
        <div
          v-else
          class="font-weight-bold text-blue text-primary"
        >
          {{ $t("kein_mitarbeiter") }}
        </div>
      </div>

    </div>
    -->

    <div class="row p-4">
      <div v-if="stornierungAnzeigen" class="col-12">
        <stornierung-alert v-if="stornierung" :stornierung="stornierung" class="mt-3"/>
      </div>
      <div v-if="kostenlosVorverlegenAnzeigen" class="col-12">
        <vorverlegen-info class="mt-3"/>
      </div>
      <div v-if="absagen" class="col-12 text-center">
        <button class="btn btn-danger w-100 mt-3" @click="$emit('absagen')">
          {{ $t("actions.termin_absagen") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import StornierungAlert from './StornierungAlert.vue';
import VorverlegenInfo from './VorverlegenInfo.vue';

  export default {
  components: { StornierungAlert, VorverlegenInfo },
    name: "TerminZusammenfassung",
    props: {
      type: {
        type: String,
        default: "desired",
      },
      absagen: {
        type: Boolean,
        default: false,
      },
      stornierungAnzeigen: {
        type: Boolean,
        default: false
      },
      kostenlosVorverlegenAnzeigen: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      time() {
        if (!this.proposal.start) return null;
        return DateTime.fromISO(this.proposal.start).toJSDate();
      },
      minDate() {
        if (!this.proposal.min_date) return null;
        return DateTime.fromISO(this.proposal.min_date).toJSDate();
      },
      maxDate() {
        if (!this.proposal.max_date) return null;
        return DateTime.fromISO(this.proposal.max_date).toJSDate();
      },
      proposal() {
        if (this.type === "actual") return this.$store.state.termin.actualTermin;
        else return this.$store.state.termin.selectedTermin;
      },
      mitarbeiter() {
        if (!this.proposal || !this.proposal.mitarbeiter) return null;
        if (Array.isArray(this.proposal.mitarbeiter))
          return this.proposal.mitarbeiter[0];
        return this.proposal.mitarbeiter;
      },
      terminart() {
        return this.$store.state.termin.behandlung;
      },
      stornierung() {
        if(this.type === "actual")
          return this.$store.state.termin?.actualTermin?.stornierung;
        else if(this.type === "desired")
          return this.$store.state.termin?.selectedTermin?.stornierung;
        else
          return null
      },
      praxis() {
        if (typeof this.$store.state.termin.praxis === "string")
          return this.$store.state.praxen.find(
            (p) => p.value === this.$store.state.termin.praxis
          );
        else return this.$store.state.termin.praxis;
      },
    },
  };
</script>

<style>
</style>
